'use strict';

const AD_SELECTOR = '.ai-inventory-placement-container';
const LOADED_ATTR = 'ad-is-loaded';

const context = {
  loadAds: (options = {}) => {
    const { shouldRefresh = false } = options;
    let { tryAmount = 0 } = options;
    const { document, window } = global;
    if (Groupon.DFPAds) {
      const unloadedAds = document.querySelectorAll(
        `${AD_SELECTOR}:not([${LOADED_ATTR}="true"])`
      );

      if (unloadedAds.length) {
        const unloadedAdIds = [];

        unloadedAds.forEach(ad => {
          ad.setAttribute(LOADED_ATTR, 'true');
          unloadedAdIds.push(ad.children[0].id);
        });

        Groupon.DFPAds.load();

        if (shouldRefresh && window.googletag && window.googletag.pubads) {
          const allAdSlots = window.googletag.pubads().getSlots();
          const slotsToRefresh = [];

          allAdSlots.forEach(slot => {
            const slotElementId = slot.getSlotElementId();
            if (unloadedAdIds.includes(slotElementId)) {
              slotsToRefresh.push(slot);
            }
          });

          window.googletag.pubads().refresh(slotsToRefresh);
        }
      }
    } else {
      if (tryAmount++ < 20) {
        setTimeout(() => {
          context.loadAds({ shouldRefresh, tryAmount });
        }, 100);
      }
    }
  },
  sanitizeAd: node => {
    node.removeAttribute(LOADED_ATTR);
    if (node.children.length) {
      node.children[0].innerHTML = '';
    }
  },
};

module.exports = context;
